export const LocalStorageKeys = Object.freeze({
  CreatePlan: 'create-plan',
  CreateInvoice: 'create-invoice',
  UpdateContract: 'update-contract',
  ReviseContract: 'revise-contract',
  IsSideBarOpen: 'side-bar-open',
  ArrMrrReportViewMode: 'arr-mrr-report-view-mode',
});
